(function (module) {
    'use strict';

    module.directive('ngFrame', () => {
        return {
            scope: {
                onFrameLoaded: '&'
            },
            link: function ($scope, element) {
                element.on('load', $scope.onFrameLoaded);
            }
        };
    });

})(angular.module('rocket.components'));
